import type { Template } from "@/types";

export const LA_05_H1_V4: Template[] = [
    {
        id: "la-05-h1v4-01",
        name: "LA 01 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 43, y: 59, width: 589, height: 412, rotation: 0, imageRotation: 0 },
            { id: "2", x: 846, y: 37, width: 164, height: 225, rotation: 0, imageRotation: 0 },
            { id: "3", x: 846, y: 270, width: 164, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 37, width: 164, height: 225, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 270, width: 164, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-02",
        name: "LA 02 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 81, y: 84, width: 514, height: 362, rotation: 0, imageRotation: 0 },
            { id: "2", x: 811, y: 57, width: 293, height: 417, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1111, y: 57, width: 108, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1111, y: 199, width: 108, height: 133, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1111, y: 341, width: 108, height: 133, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-03",
        name: "LA 03 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 128, y: 31, width: 420, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 128, y: 300, width: 135, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 271, y: 300, width: 135, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 414, y: 300, width: 134, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 848, y: 31, width: 333, height: 469, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-04",
        name: "LA 04 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 94, y: 56, width: 278, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 56, width: 201, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 190, width: 201, height: 285, rotation: 0, imageRotation: 0 },
            { id: "4", x: 769, y: 79, width: 241, height: 375, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 79, width: 241, height: 375, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-05",
        name: "LA 05 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 104, y: 87, width: 230, height: 356, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 87, width: 230, height: 356, rotation: 0, imageRotation: 0 },
            { id: "3", x: 771, y: 56, width: 278, height: 419, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1057, y: 56, width: 201, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1057, y: 190, width: 201, height: 285, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-06",
        name: "LA 06 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 190, y: 56, width: 297, height: 419, rotation: 0, imageRotation: 0 },
            { id: "2", x: 825, y: 253, width: 378, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 825, y: 56, width: 121, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 954, y: 56, width: 121, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1083, y: 56, width: 121, height: 188, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-07",
        name: "LA 07 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 61, width: 626, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 61, width: 282, height: 410, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 61, width: 136, height: 201, rotation: 0, imageRotation: 0 },
            { id: "4", x: 924, y: 269, width: 136, height: 202, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1068, y: 61, width: 284, height: 410, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-08",
        name: "LA 08 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 61, width: 626, height: 410, rotation: 0, imageRotation: 0 },
            { id: "2", x: 634, y: 61, width: 282, height: 410, rotation: 0, imageRotation: 0 },
            { id: "3", x: 924, y: 61, width: 284, height: 410, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1216, y: 61, width: 136, height: 201, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1216, y: 269, width: 136, height: 201, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h1v4-09",
        name: "LA 09 - H1V4",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h1_v4_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 34, width: 676, height: 461, rotation: 0, imageRotation: 0 },
            { id: "2", x: 842, y: 34, width: 169, height: 227, rotation: 0, imageRotation: 0 },
            { id: "3", x: 842, y: 269, width: 169, height: 227, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1019, y: 34, width: 168, height: 227, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1019, y: 269, width: 168, height: 227, rotation: 0, imageRotation: 0 }
        ],
    }
];